<template>
  <div>
    <!-- 搜索框 -->
    <div id="search">
      <div class="search">
        <div class="search_left">
          <input
            type="text"
            v-model="searchKey"
            @keyup.enter="
              $router.push({
                path: '/searchCenter',
                query: { keyword: searchKey },
              })
            "
          />
        </div>
        <div
          class="search_right"
          @click="
            $router.push({
              path: '/searchCenter',
              query: { keyword: searchKey },
            })
          "
          style="cursor: pointer"
        >
          <img src="@/assets/images/sousuo.png" alt="" />
          <span>搜索</span>
        </div>
      </div>
    </div>
    <!-- 轮播图 -->
    <div id="banner">
      <div
        class="banner"
        :style="{ left: `${left}px`, transition: transition }"
        @mouseover="clearTimer()"
        @mouseout="bannerMove()"
      >
        <img
          :src="imgUrl + bannerList[bannerList.length - 1].address"
          @click="
            openOnNewPage(
              '/companyDetail',
              bannerList[bannerList.length - 1].companyId
            )
          "
          alt=""
        />
        <img
          :src="imgUrl + item.address"
          @click="openOnNewPage('/companyDetail', item.companyId)"
          v-for="(item, index) in bannerList"
          :key="index"
          alt=""
        />
        <img
          :src="imgUrl + bannerList[0].address"
          @click="openOnNewPage('/companyDetail', bannerList[0].companyId)"
          alt=""
        />
      </div>
      <div class="banner_circle">
        <span
          v-for="(item, index) in bannerList"
          :key="index"
          @click="operateBanner(index)"
          :style="
            imgIndexCondition(index).indexOf(imgIndex) != -1 ? circleStyle : ''
          "
        ></span>
      </div>
      <div class="banner_leftBtn" @click="operateBanner(false)">
        <div></div>
      </div>
      <div class="banner_rightBtn" @click="operateBanner(true)">
        <div></div>
      </div>
      <div id="search_list">
        <div class="search_list">
          <div class="search_list_bottom">
            <ul>
              <li v-for="(items, index) in careerTagData" :key="index">
                <span>{{ items.name }}</span>
                <span
                  @click="
                    openOnNewPage(
                      '/searchCenter?keyword=' + items.careers[0].name
                    )
                  "
                  >{{ items.careers[0].name }}<span>></span></span
                >
                <div class="major-list">
                  <div>{{ items.name }}</div>
                  <div>
                    <ul>
                      <li
                        v-for="(items1, index1) in items.careers"
                        :key="index1"
                        @click="
                          openOnNewPage('/searchCenter?keyword=' + items1.name)
                        "
                      >
                        <span>{{ items1.name }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 智能推荐或热门职业 -->

    <CareerList title="智能推荐" :dataList="intellRecommendData" :condition="recCarCondition"/>
    <CareerList title="热门职业" :dataList="hotCareerData" :condition="hotCarCondition" />

    <!-- 热门企业 -->
    <div id="hot_enterprise">
      <div class="hot_enterprise">
        <div class="hot_enterprise_top">
          <div>热门企业</div>
          <div v-show="false">
            <span @click="openOnNewPage('/searchCenter')">更多</span>
            <img src="@/assets/images/jiantou.png" alt="" />
          </div>
        </div>
        <div class="hot_enterprise_bottom">
          <ul>
            <li v-for="(item, index) in hotEnterpriseData" :key="index">
              <div @click="openOnNewPage('/companyDetail', item.id)">
                <img
                  v-if="item.imageAddress"
                  :src="imgUrl + item.imageAddress"
                  alt=""
                />
                <img v-else src="@/assets/images/company.png" alt="" />
                <div>
                  <div>
                    <span>{{ item.name }}</span>
                  </div>
                  <div>
                    <span>{{ financeStageMapping[item.financeStage] }}</span>
                    <span>{{ peopleNumberMapping[item.peopleNumber] }}</span>

                    <span>{{ item.industry }}</span>
                  </div>
                  <div>
                    <img src="@/assets/images/address.png" alt="" />
                    <span>{{
                      item.address && item.address.split(",")[0]
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="enterprise_career_list">
                <div
                  v-for="(item, index) in item.careerList"
                  :key="index"
                  @click="openOnNewPage('/careerDetail', item.id)"
                >
                  <div>
                    <span>{{ item.name }}</span>
                    <span>{{ item.salary }}</span>
                  </div>
                  <div>
                    <span v-if="item.education || item.education == 0">
                      {{
                        item.education == -1
                          ? "学历不限"
                          : educationMapping[item.education]
                      }}
                    </span>
                    <span
                      v-if="item.workExperience || item.workExperience == 0"
                      >{{
                        item.workExperience == -1
                          ? "经验不限"
                          : workExperienceMapping[item.workExperience]
                      }}</span
                    >
                    <span v-for="(item, index) in item.require" :key="index">{{
                      item
                    }}</span>
                  </div>
                </div>
              </div>
              <div v-show="item.companyCareerCount">
                <span
                  @click="openOnNewPage('/companyDetail/hotCareer', item.id)"
                  >查看更多</span
                >
                <img src="@/assets/images/jiantou.png" alt="" />
              </div>
            </li>
          </ul>
          <div
            style="text-align: center; color: #666; padding-bottom: 100px"
            v-show="isFinished"
          >
            <h1>没有更多职位了</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CareerList from "@/components/CareerList.vue";
import {
  GetCareerTagAPI,
  HotEnterpriseAPI,
  HotCareerAPI,
  GetBannerAPI,
} from "../request/api.js";
import { IntellRecommendAPI } from "../request/recommend/api.js";

export default {
  components: {
    CareerList,
  },
  created() {
    this.loadingCom.start(); //开启加载动画
    this.getProfessionalTag();
    this.getBannerList();
    this.intellRecommend();
    this.getHotCareer();
    this.hotEnterprise();
    this.bannerMove(0);
  },
  data() {
    return {
      recCarCondition: {
        //推荐职位条件
        careerName: null,
        salary: null, //期望薪资 0:不限；1：3K以下；2：3K-5k ......
        city: null, //期望城市
        areaCode: null, //期望城市代码
        cityId:null, //期望城市id
        jobNature: null, //求职性质 0:实习，1：全职
        expectedIndustry: null, //期望行业
        industryCode: null, //行业编码
      },

      hotCarCondition: {
        //热门职位条件
        careerName: null,
        salary: null, //期望薪资 0:不限；1：3K以下；2：3K-5k ......
        city: null, //期望城市
        areaCode: null, //期望城市
        cityId:null, //期望城市id
        jobNature: null, //求职性质 0:实习，1：全职
        expectedIndustry: null, //期望行业
        industryCode: null, //行业编码
        sort:3,
      },
      searchKey: "",
      bannerList: [],
      educationMapping: ["大专", "本科", "硕士", "博士"],
      workExperienceMapping: [
        "应届生",
        "实习生",
        "1年以内",
        "1-3年",
        "3-5年",
        "5-10年",
        "10年以上",
      ],
      peopleNumberMapping: [
        "0-20人",
        "20-99人",
        "100-499人",
        "500-999人",
        "1000-9999人",
        "10000人以上",
      ],
      financeStageMapping: [
        "未融资",
        "天使轮",
        "A轮",
        "B轮",
        "C轮",
        "D轮及以上",
        "已上市",
        "不需要融资",
      ],
      careerTagData: [],
      intellRecommendData: [],
      hotEnterpriseData: [],
      hotCareerData: [],
      left: -1920,
      imgIndex: 0, //图片索引
      transition: "all 0.5s linear",
      timer: null,
      circleStyle: { backgroundColor: "white", border: "5px solid #c8c8c8" },
      closeCount: 3, //控制热门职业和企业全部加载完成时关闭加载动画
      isFinished: false, //是否加载完成
      isLoading: false, //是否正在加载
      currentPage: 1,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.listenTopHeight);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.listenTopHeight); //移除时间，防止其他页面也触发
  },
  methods: {
    imgIndexCondition(index) {
      if (index == 0) {
        return [0, this.bannerList.length];
      }
      return [index];
    },

    async getBannerList() {
      let info = await GetBannerAPI();
      if (info.code == 200) {
        this.bannerList = info.data;
      }
    },
    async getProfessionalTag() {
      let data = await GetCareerTagAPI();
      if (data.code == 200) {
        this.careerTagData = data.data;
      }
      this.closeCount--;
      if (this.closeCount == 0) {
        this.loadingCom.close(); // 关闭加载动画
      }
    },
    async intellRecommend() {
      let data = await IntellRecommendAPI();

      if (data.code == 200) {
        this.recCarCondition = data.data.condition;
        this.recCarCondition.cityId=data.data.cityId;
        this.intellRecommendData = data.data.careers.map((item) => {
          if (item.require) {
            item.require = item.require.split(",").splice(0, 3);
          }

          return item;
        });
      }
      this.closeCount--;
      if (this.closeCount == 0) {
        this.loadingCom.close(); // 关闭加载动画
      }
    },
    async getHotCareer() {
      let data = await HotCareerAPI();

      if (data.code == 200) {
        this.hotCarCondition = data.data.condition;
        this.hotCarCondition.cityId=data.data.cityId;
        this.hotCarCondition.sort=3;
        this.hotCareerData = data.data.careers.map((item) => {
          if (item.require) {
            item.require = item.require.split(",").splice(0, 3);
          }

          return item;
        });
      }
    },

    async hotEnterprise(currentPage) {
      let data = await HotEnterpriseAPI(currentPage);
      if (data.code == 200) {
        this.hotEnterpriseData = data.data.map((element) => {
          element.careerList = element.careerList.map((item) => {
            item.require = item.require.split(",").splice(0, 5);
            return item;
          });
          element.companyCareerCount =
            element.companyCareerCount > 3 ? true : false;
          return element;
        });
      }

      this.closeCount--;
      if (this.closeCount == 0) {
        this.loadingCom.close(); // 关闭加载动画
      }
    },
    //上拉获取数据
    async listenTopHeight() {
      console.log(
        document.documentElement.scrollHeight -
          document.documentElement.clientHeight
      );
      console.log(Math.ceil( document.documentElement.scrollTop));
      if (
        //提前50像素距离触发
        Math.ceil( document.documentElement.scrollTop)- 50 ==
          document.documentElement.scrollHeight -
            document.documentElement.clientHeight -
            50 &&
        document.documentElement.scrollTop != 0
      ) {
        if (this.isFinished) {
          //如果数据已经加载完了，就没有必要再发送请求
          return;
        }
        //防止发送多次请求
        if (this.loading) {
          return;
        }
        //发送请求

        this.loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        //获取下一页的数据
        let info = await HotEnterpriseAPI(this.currentPage + 1);
        this.loading.close();
        this.loading = null;
        if (info.code == 200) {
          if (info.data.length < 12) {
            this.isFinished = true;
          } else {
            this.currentPage++;
          }

          let d = info.data.map((element) => {
            element.careerList = element.careerList.map((item) => {
              item.require = item.require.split(",").splice(0, 5);
              return item;
            });
            element.companyCareerCount =
              element.companyCareerCount > 3 ? true : false;
            return element;
          });

          this.hotEnterpriseData = [...this.hotEnterpriseData, ...d];
        } else {
          this.$message.error("数据加载失败，请稍后重试");
        }
      }
    },
    bannerMove() {
      this.bannerBtnShow = false;
      this.timer = setInterval(() => {
        this.imgIndex++;
        if (this.imgIndex >= this.bannerList.length + 1) {
          this.transition = "none";
          this.imgIndex = 0;
          this.left = -(this.imgIndex * 1920 + 1920);

          setTimeout(() => {
            this.imgIndex++;
            this.left = -(this.imgIndex * 1920 + 1920);
            this.transition = "all 0.5s linear";
          }, 1);
        } else {
          this.left = -(this.imgIndex * 1920 + 1920);
        }
      }, 3000);
    },
    operateBanner(i) {
      // true 下一张 ； false 上一张  ； 数字代表某一张
      this.clearTimer();
      if (typeof i == "boolean") {
        if (i) {
          this.imgIndex++;
        } else {
          this.imgIndex--;
        }
        console.log(this.imgIndex);
        if (this.imgIndex <= -1) {
          this.transition = "none";
          this.imgIndex = this.bannerList.length;
          this.left = -(this.imgIndex * 1920 + 1920);

          setTimeout(() => {
            this.imgIndex--;
            this.left = -(this.imgIndex * 1920 + 1920);
            this.transition = "all 0.5s linear";
          }, 1);
        } else if (this.imgIndex >= this.bannerList.length + 1) {
          this.transition = "none";
          this.imgIndex = 0;
          this.left = -(this.imgIndex * 1920 + 1920);

          setTimeout(() => {
            this.imgIndex++;
            this.left = -(this.imgIndex * 1920 + 1920);
            this.transition = "all 0.5s linear";
          }, 1);
        } else {
          // this. transition='all 1s linear',
          this.left = -(this.imgIndex * 1920 + 1920);
        }
      } else {
        this.imgIndex = i;
        this.transition = "none";
        this.left = -(this.imgIndex * 1920 + 1920);
        setTimeout(() => {
          this.transition = "all 0.5s linear";
        }, 1);
      }

      this.bannerMove();
    },
    clearTimer() {
      clearInterval(this.timer);
    },
  },

  updated() {},
};
</script>

<style scoped>
#search {
  height: 100px;

  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search {
  height: 50px;

  top: 23px;

  width: 700px;

  border: 2px solid #24adde;
  border-radius: 19px 19px 19px 19px;
  border-right: 0;
}

.search .search_left {
  float: left;
  width: 600px;
}

.search .search_left input {
  width: 560px;
  height: 30px;
  padding: 10px 10px;
}

.search .search_right {
  width: 100px;
  height: 50px;
  background-color: #24adde;
  float: right;
  border-radius: 0 19px 19px 0;
}

.search .search_right img {
  width: 18px;
  height: 18px;
  margin: 10px 10px 10px 15px;
  vertical-align: middle;
}

.search .search_right span {
  color: #fff;
  line-height: 50px;
}

#banner {
  position: relative;
  min-width: 1200px;
  height: 450px;
  overflow: hidden;
  white-space: nowrap;
}
#banner:hover > .banner_leftBtn {
  opacity: 1;
}
#banner:hover > .banner_rightBtn {
  opacity: 1;
}
.banner {
  position: absolute;

  top: 0;
  width: calc(5 * 1920px);
  margin: auto;
}
.banner_circle {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 10px;
  left: calc(50% - calc(3 * 27px));
}
.banner_circle span {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: transparent;
  margin: 0 5px;
  cursor: pointer;
  border: 2px solid #c8c8c8;
  transition: background-color 0.5s ease;
}
/* .banner_circle span:hover{
  background-color: #24adde;
} */
.banner img {
  width: 1920px;
  height: 450px;
}
.banner_leftBtn {
  opacity: 0;
  border-radius: 4px;
  position: absolute;
  width: 40px;
  height: 80px;
  background-color: white;
  left: 10px;
  top: calc(50% - 80px / 2);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.5s;
}
/* .banner_leftBtn:hover{
   opacity: 1;

} */
.banner_leftBtn div {
  border: 10px solid transparent;
  border-right: 10px solid black;
  margin-right: 10px;
}

.banner_rightBtn {
  opacity: 0;
  border-radius: 4px;
  position: absolute;
  width: 40px;
  height: 80px;
  background-color: white;
  right: 10px;
  top: calc(50% - 80px / 2);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.5s;
}
/* .banner_rightBtn:hover{
   opacity: 1;
   
} */
.banner_rightBtn div {
  border: 10px solid transparent;
  border-left: 10px solid black;
  margin-left: 10px;
}

#search_list {
  width: 1200px;
  height: 450px;

  position: absolute;
  pointer-events: none;
  top: 0;
  left: calc(50% - 600px);
}

.search_list {
  width: 250px;
  height: 450px;
  pointer-events: all;
}

.search_list_bottom {
  width: 250px;
  height: 600px;
}

.search_list_bottom > ul {
  width: 260px;
  height: 600px;
  background-color: rgb(255, 255, 255, 0.7);
  position: relative;
}

.search_list_bottom > ul > li {
  width: 260px;
  height: 50px;
}

.search_list_bottom > ul > li > span {
  line-height: 50px;
}

.search_list_bottom > ul > li > span:first-child {
  float: left;
  margin-left: 30px;

  font-weight: 600;
}

.search_list_bottom > ul > li > span:nth-child(2) {
  max-width: 160px;
  color: #999;
  font-size: 14px;
  float: right;
  margin-right: 10px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.search_list_bottom > ul > li > span:nth-child(2) > span {
  margin-left: 10px;
}

.search_list_bottom ul li:hover > .major-list {
  display: block;
}

.search_list_bottom > ul > li:hover > span:first-child {
  color: #24ade1;
}

.major-list {
  width: 600px;
  position: absolute;
  background-color: white;
  padding-left: 20px;
  padding-bottom: 20px;
  padding-right: 20px;
  top: 0;
  left: 250px;
  display: none;
}

.major-list div:first-child {
  font-weight: 600;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #edf1f9;
  margin-bottom: 10px;
}

.major-list div:last-child ul {
  display: flex;
  flex-wrap: wrap;
}

.major-list div:last-child ul li {
  height: 25px;
  width: 200px;
  margin-bottom: 10px;
  color: #999;
  font-size: 14px;
}

.major-list div:last-child > ul > li > span:hover {
  color: #24ade1;

  cursor: pointer;
}

#hot_enterprise {
  min-height: 1400px;
  margin: 10px 0;
}

.hot_enterprise {
  width: 1200px;
  height: 1400px;
  margin: auto;
}

.hot_enterprise_top {
  height: 60px;
  background-color: white;
  border: 1px solid #24adde;
}

.hot_enterprise_top div {
  width: 150px;
}

.hot_enterprise_top div:nth-child(1) {
  float: left;
  text-align: center;
  line-height: 60px;

  font-size: 30px;
  font-weight: 600;
  color: #000;
}

.hot_enterprise_top div:nth-child(2) {
  float: right;
  text-align: right;
  line-height: 60px;
  padding-right: 10px;
}

.hot_enterprise_top div:nth-child(2) img {
  vertical-align: middle;
}

.hot_enterprise_top div:nth-child(2):hover {
  color: #24ade1;
  cursor: pointer;
}

.hot_enterprise_bottom ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-content: space-between;
  padding-bottom: 80px;
}

.hot_enterprise_bottom ul li {
  cursor: pointer;
  border-radius: 5px;
  padding: 15px;
  width: 360px;
  height: 380px;
  margin-bottom:15px;
  background-color: white;
}

.hot_enterprise_bottom ul > li > div:nth-child(1) {
  width: 100%;
  height: 100px;
}

.hot_enterprise_bottom
  ul
  > li
  > div:nth-child(1):hover
  > div
  > div:nth-child(1)
  > span {
  color: #24ade1;
}

.hot_enterprise_bottom ul > li > div:nth-child(1) > img {
  width: 100px;
  height: 100px;
  float: left;
}

.hot_enterprise_bottom ul > li > div:nth-child(1) > div {
  margin-left: 10px;
  width: 250px;
  float: left;
}

.hot_enterprise_bottom ul > li > div:nth-child(1) > div div:nth-child(2) {
  margin: 5px 0;
  overflow: hidden;

  white-space: nowrap;
}

.hot_enterprise_bottom ul > li > div:nth-child(1) > div div:nth-child(1) {
  margin-top: 10px;
}

.hot_enterprise_bottom ul > li > div:nth-child(1) > div div:nth-child(1) span {
  width: 250px;
  font-size: 18px;
  font-weight: 500;
  color: #000;
}

.hot_enterprise_bottom ul > li > div:nth-child(1) > div div:nth-child(2) span {
  font-size: 15px;
  font-weight: 400;
  color: #999;
  margin-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100px;
}

.hot_enterprise_bottom ul > li > div:nth-child(1) > div div:nth-child(3) img {
  width: 15px;
  height: 15px;
  vertical-align: middle;
}
.hot_enterprise_bottom ul > li > div:nth-child(1) > div div:nth-child(3) {
  display: flex;
  align-items: center;
}
.hot_enterprise_bottom ul > li > div:nth-child(1) > div div:nth-child(3) span {
  font-size: 15px;
  font-weight: 400;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 230px;
}

.enterprise_career_list {
  padding: 10px;
  background-color: #f7fcfc;
  margin-top: 10px;
  display: flex;
  flex-direction: column;

  height: 230px;
}

.enterprise_career_list > div {
  height: 70px;
}

.enterprise_career_list > div:hover > div:nth-child(1) span:nth-child(1) {
  color: #24ade1;
}

.enterprise_career_list > div > div:nth-child(1) {
  margin-bottom: 10px;
  overflow: hidden;
}

.enterprise_career_list > div > div:nth-child(1) > span:nth-child(1) {
  width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 500;
  color: #000;
  float: left;
}

.enterprise_career_list > div > div:nth-child(1) > span:nth-child(2) {
  font-size: 15px;
  font-weight: 500;
  color: #ff6400;
  float: right;
}
.enterprise_career_list > div > div:nth-child(2) {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.enterprise_career_list > div > div:nth-child(2) > span {
  margin-right: 10px;
  background-color: white;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: 400;
  color: #999;
  border-radius: 6px;
}

.hot_enterprise_bottom > ul > li > div:nth-child(3) {
  text-align: center;
}

.hot_enterprise_bottom > ul > li > div:nth-child(3) span {
  padding: 5px;
  cursor: pointer;
  display: inline-block;
}

.hot_enterprise_bottom > ul > li > div:nth-child(3) img {
  vertical-align: middle;
}

.hot_enterprise_bottom > ul > li > div:nth-child(3) span:hover {
  color: #24ade1;
}
</style>